import CryptoJS from 'crypto-js';

const SECRET_KEY = "nJduJfvbkaY9bjY7nHZLv3MHb5hKRnmivFSnlPvq2Ho="; // must match C# exactly

export function computeChecksum(data) {
    const hash = CryptoJS.HmacSHA256(data, SECRET_KEY);
    const hashHex = hash.toString(CryptoJS.enc.Hex).toUpperCase();
    return hashHex.substring(0, 4); // first 2 bytes = 4 hex chars, matches C# side
}

// Format: KHOR-{snippet}-{dateCode}-{modelId}-{checksum}
// snippet: 8 chars (issuer's Azure object ID, dashes removed)
// dateCode: 4 chars, MMdd UTC
// modelId: 6 uppercase hex chars, random per model
// checksum: 4 uppercase hex chars, HMAC-SHA256 of "{snippet}-{dateCode}-{modelId}"
export function decodeAccessCode(code) {
    const parts = code.trim().split('-');

    if (parts.length !== 5 || parts[0] !== 'KHOR') {
        return null;
    }

    const [, snippet, dateCode, modelId, providedChecksum] = parts;

    if (snippet.length !== 8 || dateCode.length !== 4 || modelId.length !== 6) {
        return null;
    }

    const dataToSign = `${snippet}-${dateCode}-${modelId}`;
    const expectedChecksum = computeChecksum(dataToSign);

    if (providedChecksum !== expectedChecksum) {
        return null; // Tampered or invalid
    }

    return { objectIdSnippet: snippet, dateGenerated: dateCode, modelId };
}
